import { Directive, HostBinding, Input } from '@angular/core';
import { UserProfileService } from '../api/user-profile.service';
import { TransactionService } from '../api/transaction.service';

@Directive({
  selector: '[ivEnabledForPartialCredit]'
})
export class EnabledForPartialCreditDirective {

  userRoles: any;

  @Input('ivEnabledForPartialCredit') data: {
    editable: boolean,
    transaction?: any
  };

  @HostBinding('class')
  get elementClass(): string {
    if (this.transactionService.isAdjustBillLines(this.data?.transaction)) {
      if (!this.data.editable) {
        return 'enabled-for-partial-credit enabled-for-partial-credit__non-editable';
      } 
      return !['financial_user', 'support_user'].includes(this.currentUserRole) ? 'enabled-for-partial-credit enabled-for-partial-credit__editable' : '';
    }
    return '';
  }

  constructor(
    private userProfileService: UserProfileService,
    private transactionService: TransactionService
  ) {
    this.userRoles = this.userProfileService.getUserRoles();
  }

  get currentUserRole(): string | any {
    const currentRole = this.userRoles.filter((role: any) => role.value === 'true');
    if (currentRole && currentRole.length === 1) {
      return currentRole[0].key;
    }
    return '';
  }

}
